import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import MemberName from '../../../../../../../common/components/MemberName';
import RoleIcons from '../../../../../../../common/components/RoleIcons';
import { useWidget } from '../../../../../../../contexts/widgets';
import { DataHook, ProfileAlignment } from '../../../../../../../types';
import styles from './Name.scss';

export const Name: FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useEnvironment();
  const { member, site, rolesMap, computed } = useWidget();

  const { profileAlignment, showRoleLabel } = computed;
  const { isSocial } = site;

  const isRightAlignment =
    profileAlignment === ProfileAlignment.Right && !isRTL;
  const isCenterAlignment = profileAlignment === ProfileAlignment.Center;

  return (
    <div
      data-hook={DataHook.MemberName}
      className={classNames({
        [styles.container]: true,
        [styles.isRightAlignment]: isRightAlignment,
        [styles.isCenterAlignment]: isCenterAlignment,
      })}
    >
      <div className={styles.nameWrapper}>
        <MemberName
          name={member.name}
          className={styles.nameBoxText}
          tooltipClass={styles.tooltipWrapper}
        />
      </div>
      {isSocial && showRoleLabel && (
        <RoleIcons
          t={t}
          containerClassName={styles.roleIcons}
          iconClassName={styles.roleIcon}
          roles={member.roles}
          rolesMap={rolesMap}
          withNames={true}
        />
      )}
    </div>
  );
};
